module.exports = __webpack_public_path__ + "assets/images/cdb1f688026e1c497291068394a122db.png";